/* Sondur Travel — comportamento das PDPs montadas no construtor de páginas da referência (família "pdp-gp").
   Substitui o runtime do GemPages (gp-carousel-v7-5.js) no único ponto em que ele muda algo
   para quem usa a página: o carrossel. O acordeão vem do ewc-pagina.js e as avaliações do
   sd-reviews.js (os dois já existem no tema).

   O que a sonda na referência mediu (work/probe-ref-gp.json), e é o que está reproduzido aqui:
     - clicar a miniatura 3 põe active-index="2" no <gp-carousel> da foto grande e
       transform: translate3d(-1140px,0,0) em TODOS os .gem-slider-item (570px × 2) — é assim
       que o keen-slider do GemPages anda: o mesmo deslocamento em cada item, não no trilho;
     - o data-outline="active" muda de miniatura;
     - a seta desabilitada fica com data-hidden="true" disabled e visibility:hidden (foi assim
       que a captura trouxe a seta "voltar" das duas galerias);
     - a barra fixa (gp-sticky) NÃO aparece em nenhum tamanho: --d/--d-tablet/--d-mobile são
       "none" e continuam "none" depois de rolar a página inteira (medido na referência).
       Por isso aqui não há nada que a mostre.
   Nada é tocado ao carregar: só o clique mexe na página (a árvore nasce igual à da captura). */
(function () {
  'use strict';

  function itens(car) {
    var trilho = car.querySelector('.gem-slider');
    if (!trilho) return [];
    return [].filter.call(trilho.children, function (c) {
      return c.classList && c.classList.contains('gem-slider-item');
    });
  }

  /* largura de um item + o espaço entre itens (o trilho é flex) */
  function passo(lista) {
    if (lista.length < 2) return lista.length ? lista[0].getBoundingClientRect().width : 0;
    var a = lista[0].getBoundingClientRect(), b = lista[1].getBoundingClientRect();
    return Math.round((b.left - a.left) * 100) / 100 || a.width;
  }

  /* quantos itens cabem na janela do trilho (para saber onde a seta "avançar" acaba) */
  function visiveis(car, p) {
    var trilho = car.querySelector('.gem-slider');
    if (!trilho || !p) return 1;
    return Math.max(1, Math.round(trilho.getBoundingClientRect().width / p));
  }

  function seta(car, qual) {
    var b = car.querySelectorAll('.gp-carousel-action-' + qual);
    for (var i = 0; i < b.length; i++) {
      if (b[i].closest('gp-carousel') === car) return b[i];
    }
    return null;
  }

  function marcarSeta(b, desabilitada) {
    if (!b) return;
    b.setAttribute('data-hidden', desabilitada ? 'true' : 'false');
    if (desabilitada) {
      b.setAttribute('disabled', '');
      b.style.setProperty('visibility', 'hidden', 'important');
    } else {
      b.removeAttribute('disabled');
      b.style.removeProperty('visibility');
    }
  }

  function pontos(car, i) {
    var cont = car.querySelector('.gp-carousel-dot-container');
    if (!cont) return;
    var ds = cont.querySelectorAll('.gp-carousel-dot');
    for (var k = 0; k < ds.length; k++) {
      var ativo = (k === i);
      ds[k].classList.toggle('gp-carousel-dot--active', ativo);
      ds[k].classList.toggle('gem-slider-dot-active', ativo);
      ds[k].classList.toggle('gem-slider-dot-inactive', !ativo);
    }
  }

  function loopLigado(car) {
    var cel = window.matchMedia('(max-width: 767px)').matches;
    return car.getAttribute(cel ? 'data-ewc-loop-mobile' : 'data-ewc-loop') === '1';
  }

  function ir(car, i, comOutline) {
    var lista = itens(car);
    if (!lista.length) return;
    var p = passo(lista);
    var vis = visiveis(car, p);
    var ultimo = Math.max(0, lista.length - vis);
    if (loopLigado(car)) {
      if (i < 0) i = ultimo;
      if (i > ultimo) i = 0;
    } else {
      i = Math.min(Math.max(i, 0), ultimo);
    }
    var x = -(i * p);
    for (var k = 0; k < lista.length; k++) {
      /* !important no proprio elemento: a secao tem uma @media (max-width:767px) com o
         transform que o runtime da referencia escreveu em 390 (o escalonamento da espiada das
         miniaturas), e ela tambem e !important — inline com !important ganha das duas. */
      lista[k].style.setProperty('transform', 'translate3d(' + x + 'px, 0px, 0px)', 'important');
      if (comOutline) lista[k].setAttribute('data-outline', k === i ? 'active' : 'deactive');
    }
    car.setAttribute('active-index', String(i));
    pontos(car, i);
    if (!loopLigado(car)) {
      marcarSeta(seta(car, 'back'), i <= 0);
      marcarSeta(seta(car, 'next'), i >= ultimo);
    }
    return i;
  }

  function indice(car) {
    return parseInt(car.getAttribute('active-index') || '0', 10) || 0;
  }

  function ligar(car) {
    if (car.dataset.ewcLigado) return;
    car.dataset.ewcLigado = '1';
    var lista = itens(car);
    if (!lista.length) return;
    var galeria = car.classList.contains('carousel-gallery');
    var b = seta(car, 'back'), n = seta(car, 'next');
    if (b) b.addEventListener('click', function (e) { e.preventDefault(); ir(car, indice(car) - 1, false); });
    if (n) n.addEventListener('click', function (e) { e.preventDefault(); ir(car, indice(car) + 1, false); });

    if (!galeria) return;
    /* galeria de miniaturas: a miniatura clicada vira a foto grande do mesmo bloco de produto */
    var bloco = car.closest('gp-product-images') || car.parentElement;
    var principal = bloco && bloco.querySelector('gp-carousel.gp-feature-image-carousel');
    if (!principal) {
      var todos = bloco ? bloco.querySelectorAll('gp-carousel') : [];
      principal = todos.length ? todos[0] : null;
    }
    lista.forEach(function (mini, k) {
      mini.addEventListener('click', function () {
        lista.forEach(function (o, j) { o.setAttribute('data-outline', j === k ? 'active' : 'deactive'); });
        if (principal && principal !== car) ir(principal, k, false);
      });
    });
  }

  function ligarTudo() {
    [].forEach.call(document.querySelectorAll('gp-carousel[data-ewc-carrossel]'), ligar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligarTudo);
  else ligarTudo();
})();
